module.exports = __webpack_public_path__ + "b486480205846a73a710a4add86652a7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/shield.png
// module id = 2119
// module chunks = 0